export default __webpack_public_path__ + "static/media/speed.da84f034.svg";